import Store from "../redux/Store";

export const getAccessTokenFromState = () => {
  try {
    const state = Store.getState();
    return state?.auth?.accessToken || null;
  } catch (e) {
    return null;
  }
};

export const getAccessToken = () => {
  return getAccessTokenFromState();
};

export default getAccessToken;